import { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { supabase } from '../../lib/supabaseClient.ts';

function ShopAll() {
    const { categoryName } = useParams();
    const [categories, setCategories] = useState([]);
    const [subcategoriess, setSubcategories] = useState([]);

    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(""); 
    const [selectedCategoryName, setSelectedCategoryName] = useState("");

    const [selectedSubcategory, setSelectedSubcategory] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState("");
    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(200);
    const [selectedMaxPrice, setSelectedMaxPrice] = useState(200);
    const [showFilter, setShowFilter] = useState(false);
    const [products, setProducts] = useState([]);

    // Add a ref to track if component is mounted
    const isMountedRef = useRef(true);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768); 
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);
    // Cleanup function to set mounted status to false
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (categoryName) {
            setSelectedCategory(decodeURIComponent(categoryName));
            setSelectedSubcategory("");
        }
    }, [categoryName]);

    const fetchCategories = async () => {
        try {
            const { data, error } = await supabase
                .from("categories")
                .select("id, name");

            if (error) {
                console.error("Error fetching categories:", error);
                return;
            }

            // Only update state if component is still mounted
            if (!isMountedRef.current) return;

            setCategories(data);
            console.log("🏷️ Catégories chargées:", data);

        } catch (err) {
            console.error("Error in fetchCategories:", err);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchSubcategories = async (categoryId) => {
        if (!categoryId) {
            if (isMountedRef.current) {
                setSubcategories([]);
            }
            return;
        }

        console.log("Fetching subcategories for categoryId:", categoryId);

        try {
            const { data, error } = await supabase
                .from("subcategories")
                .select("*")
                .eq("category_id", categoryId);

            if (error) {
                console.error("Error fetching subcategories:", error);
                if (isMountedRef.current) {
                    setSubcategories([]);
                }
                return;
            }

            // Only update state if component is still mounted
            if (!isMountedRef.current) return;

            console.log("Subcategories fetched:", data);
            setSubcategories(data || []);
        } catch (err) {
            console.error("Error in fetchSubcategories:", err);
            if (isMountedRef.current) {
                setSubcategories([]);
            }
        }
    };

    useEffect(() => {
        if (selectedCategoryId) {
            fetchSubcategories(selectedCategoryId);
        } else {
            if (isMountedRef.current) {
                setSubcategories([]);
            }
        }
    }, [selectedCategoryId]);

    useEffect(() => {
        fetchProducts();
    }, []);

    // FIX: Correction des noms de champs selon ta DB
    const fetchProducts = async () => {
        try {
            const { data, error } = await supabase
                .from("products")
                .select("*");

            if (error) {
                console.error("Error fetching products:", error);
                return;
            }

            // Only proceed if component is still mounted
            if (!isMountedRef.current) return;

            // 🔍 DEBUG: Vérifier les données
            console.log("📦 Produits récupérés:", data);
            console.log("📦 Nombre total:", data?.length || 0);

            if (data && data.length > 0) {
                console.log("📦 Premier produit:", data[0]);
                console.log("📦 Champs disponibles:", Object.keys(data[0]));

                // Vérifier les catégories dans les produits
                const uniqueCategories = [...new Set(data.map(p => p.category))];
                console.log("📦 Catégories dans produits:", uniqueCategories);
            }

            // Filter duplicates
            const uniqueProducts = [];
            const seen = new Set();

            for (const product of data || []) {
                const key = `${product.name}-${product.brand}`;
                if (!seen.has(key)) {
                    seen.add(key);
                    uniqueProducts.push(product);
                }
            }

            console.log("📦 Produits uniques:", uniqueProducts.length);

            // Final check before updating state
            if (isMountedRef.current) {
                setProducts(uniqueProducts);
            }
        } catch (err) {
            console.error("Error in fetchProducts:", err);
        }
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedCategory, selectedSubcategory]);

    const subcategories = subcategoriess || [];

    let filteredCount = 0;

    const filteredProducts = products.filter((product) => {
const matchesCategory = selectedCategory === "" || (() => {
  try {
    const cats = JSON.parse(product.category);
    return Array.isArray(cats) ? cats.includes(selectedCategory) : product.category === selectedCategory;
  } catch {
    return product.category === selectedCategory;
  }
})();        const matchesSubcategory = selectedSubcategory === "" || product.subcategory === selectedSubcategory;
        const matchesSearch = product.name?.toLowerCase().includes(searchTerm.toLowerCase());

const numericPrice = parseFloat(
  (product.price_range || "")
    .replace(/[^\d,\.]/g, "")  // remove letters/spaces
    .replace(",", ".")          // normalize decimal separator
);
        const matchesPrice = !isNaN(numericPrice) ? numericPrice <= selectedMaxPrice : true;

        const result = matchesCategory && matchesSubcategory && matchesSearch && matchesPrice;

        // Log details for first 5 matched products only
        if (result && filteredCount < 5) {
            console.log(`🔍 FILTRAGE: ${product.name}`);
            console.log(`  - Catégorie: "${product.category}" vs "${selectedCategory}" = ${matchesCategory}`);
            console.log(`  - Sous-catégorie: "${product.subcategory}" vs "${selectedSubcategory}" = ${matchesSubcategory}`);
            console.log(`  - Recherche: "${searchTerm}" = ${matchesSearch}`);
            console.log(`  - Prix: ${product.price_range} -> ${numericPrice} <= ${selectedMaxPrice} = ${matchesPrice}`);
            console.log(`  - RÉSULTAT: ${result}`);
            filteredCount++;
        }

        return result;
    });

    const totalPages = Math.ceil(filteredProducts.length / productsPerPage);
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProducts = filteredProducts.slice(startIndex, startIndex + productsPerPage);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm, selectedCategory, selectedSubcategory]);

    console.log("🔎 Recherche :", searchTerm, "| Résultats:", filteredProducts.length);

    const handleCategoryChange = (categoryName) => {
        // Si l'utilisateur clique sur la catégorie déjà sélectionnée, on désélectionne
        if (selectedCategory === categoryName) {
            setSelectedCategory("");
            setSelectedCategoryId(null);
            setSelectedCategoryName("");
            setSelectedSubcategory("");
        } else {
            const category = categories.find(cat => cat.name === categoryName);
            if (category) {
                setSelectedCategory(categoryName);
                setSelectedCategoryId(category.id);
                setSelectedCategoryName(categoryName);
                setSelectedSubcategory("");
            }
        }
    };

    return (
        <div className="shop-area pt-110 pb-110">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-3 col-md-8 order-2 order-lg-0">
                        <aside className="shop-sidebar">
                            <div className="widget">
                                <div className="sidebar-search">
                                    <form onSubmit={(e) => e.preventDefault()}>
                                        <input
                                            type="text"
                                            placeholder="Rechercher un produit..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                        <button type="submit"><i className="fa fa-search" /></button>
                                    </form>
                                </div>
                            </div>

                            <div className="widget">
                                <h4 className="sidebar-title">Catégories</h4>
                                <div className="shop-cat-list">
                                    <ul>
                                        {categories.map(cat => (
                                            <li key={cat.id}>
                                                <Link
                                                    to="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleCategoryChange(cat.name);
                                                    }}
                                                    style={{
                                                        fontWeight: selectedCategory === cat.name ? 'bold' : 'normal',
                                                        color: selectedCategory === cat.name ? '#ff69b4' : 'inherit'
                                                    }}
                                                >
                                                    {cat.name} <span>+</span>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <div className="widget">
                                <h4 className="sidebar-title">Filtrer par prix</h4>
                                <div className="price_filter">
                                    <label htmlFor="priceRange" style={{ display: "block", marginBottom: "10px", color: "#555" }}>
                                        Prix max : {selectedMaxPrice} DT
                                    </label>
                                    <input
                                        type="range"
                                        id="priceRange"
                                        min={minPrice}
                                        max={maxPrice}
                                        value={selectedMaxPrice}
                                        onChange={(e) => setSelectedMaxPrice(Number(e.target.value))}
                                        style={{ width: "100%" }}
                                    />
                                </div>
                            </div>
                        </aside>
                    </div>

                    <div className="col-lg-9">
                        <div className="shop-wrap">
                            <h4 className="title">BOUTIQUE</h4>
                       <button
  className="filter-btn"
  onClick={() => setShowFilter(true)}
  style={{
    position: "absolute",      // ensures it stays in viewport
    top: "-30px",            // distance from top
    right: "10px",          // distance from right
    backgroundColor: "#ff69b4",
    color: "#fff",
    padding: "10px 12px",   // slightly larger for mobile tap
    borderRadius: "50%",
    fontSize: "16px",
    zIndex: 99999,          // make sure it's above everything
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)", // optional shadow
  }}
>
  <i className="fa fa-filter" />
</button>

                            <div className="shop-page-meta mb-30">
                                <div className="shop-grid-menu">
                                    <ul>
                                        <li className="active"><a href="#"><i className="fas fa-th" /></a></li>
                                        <li><a href="#"><i className="fas fa-list" /></a></li>
                                    </ul>
                                </div>
                                <div className="shop-showing-result">
                                    <p>Total Produits {filteredProducts.length}</p>
                                </div>
                            </div>


                            {/* Sous-catégories dynamiques */}
                            {subcategories.length > 0 && (
                                <div
                                    className="subcategory-filter d-flex justify-content-start mb-4"
                                    style={{
                                        gap: "10px",
                                        overflowX: "auto",
                                        paddingBottom: "10px",
                                        WebkitOverflowScrolling: "touch",
                                        scrollbarWidth: "none",
                                    }}
                                >
                                    {[{ name: "Tous" }, ...subcategories].map((sub, index) => {
                                        const subName = sub.name || sub;
                                        const isSelected = selectedSubcategory === subName || (subName === "Tous" && selectedSubcategory === "");

                                        return (
                                            <button
                                                key={subName + index}
                                                onClick={() => setSelectedSubcategory(subName === "Tous" ? "" : subName)}
                                                style={{
                                                    borderRadius: "12px",
                                                    minWidth: "70px",
                                                    height: "36px",
                                                    border: isSelected ? "3px solid #ff66cc" : "2px solid #e6a8c8",
                                                    backgroundColor: isSelected ? "#ffe6f0" : "#fff",
                                                    cursor: "pointer",
                                                    textAlign: "center",
                                                    lineHeight: "36px",
                                                    whiteSpace: "nowrap",
                                                    fontSize: "14px",
                                                    userSelect: "none",
                                                    padding: "0 15px",
                                                    color: isSelected ? "#c71585" : "#333",
                                                    transition: "all 0.3s ease",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                {subName}
                                            </button>
                                        );
                                    })}
                                </div>
                            )}

                            {/* Produits */}
                            <div className="row justify-content-center">
                                {currentProducts.length > 0 ? (
                                    currentProducts.map((product) => (
                                        <div key={product.id} className="col-lg-4 col-sm-6">
                                            <div className="shop-item mb-55">
                                                <div className="shop-thumb" style={{ position: "relative", overflow: "hidden", textAlign: "center", height: "260px", }}>
                                                    {product.promo && (
                                                        <Link
                                                            to={`/shop-details/${product.id}`}>
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "10px",
                                                                    right: "10px",
                                                                    backgroundColor: "green",
                                                                    color: "#fff",
                                                                    padding: "4px 8px",
                                                                    borderRadius: "12px",
                                                                    fontSize: "12px",
                                                                    fontWeight: "600",
                                                                    zIndex: 10
                                                                }}
                                                            >
                                                                {product.promo_percentage ? `-${product.promo_percentage}%` : 'Promo'}
                                                            </div></Link>
                                                    )}
                                                    {/* Stock Badge */}
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: "10px",
                                                            left: "10px",
                                                            backgroundColor:
                                                                product.stock_status.toLowerCase() === "en stock" ? "#28a745" : "#dc3545", // green if "en stock", red otherwise
                                                            color: "#fff",
                                                            padding: "4px 8px",
                                                            borderRadius: "12px",
                                                            fontSize: "12px",
                                                            fontWeight: "600",
                                                            zIndex: 10,
                                                        }}
                                                    >
                                                        {product.stock_status}
                                                    </div>

                                                    <Link to={`/shop-details/${product.id}`}>
                                                        <img
                                                            src={product.image}
                                                            alt={product.name}
                                                            style={{
                                                                width: "45%",
                                                                height: "190px",
                                                                objectFit: "contain",
                                                                borderRadius: "8px",
                                                                transition: "transform 0.3s ease",
                                                                marginLeft: isMobile ? "auto" : "55px",
                                                                display: "block",
                                                            }}
                                                        />
                                                    </Link>

                                                    {!isMobile && (
                                                        <Link
                                                            to={`/shop-details/${product.id}`}
                                                            className="details-hover-btn"
                                                            style={{
                                                                position: "absolute",
                                                                top: "12px",
                                                                left: "50%",
                                                                transform: "translateX(-50%)",
                                                                padding: "6px 12px",
                                                                fontSize: "12px",
                                                                backgroundColor: "#ff69b4",
                                                                color: "#fff",
                                                                borderRadius: "20px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "6px",
                                                                textDecoration: "none",
                                                                zIndex: 5,
                                                                marginTop: 170
                                                            }}
                                                        >
                                                            Détails
                                                            <img
                                                                src="img/icon/w_pawprint.png"
                                                                alt=""
                                                                style={{ width: "14px", height: "14px" }}
                                                            />
                                                        </Link>
                                                    )}

                                                </div>

                                                <div className="shop-content">
                                                    <span>
                                                        {product.category
                                                            ? (() => {
                                                                try {
                                                                    const categories = JSON.parse(product.category); // parse stringified array
                                                                    return Array.isArray(categories) ? categories.join(", ") : categories;
                                                                } catch (e) {
                                                                    return product.category; // fallback if not JSON
                                                                }
                                                            })()
                                                            : "Catégorie"}
                                                    </span>

                                                    <h4 className="title">
                                                        <Link to={`/shop-details/${product.id}`}>{product.name}</Link>
                                                    </h4>



                                                    {(product.price_range || product.oldPrice) && (
                                                        <div
                                                            className="shop-content-bottom text-center mt-3"
                                                            style={{
                                                                display: "inline-block",
                                                                padding: "14px 24px",
                                                                borderRadius: "16px",
                                                                background: "linear-gradient(135deg, #fff 0%, #fffbfd 100%)",
                                                                border: "2px solid #ffe6f2",
                                                                boxShadow: "0 6px 20px rgba(255, 105, 180, 0.12)",
                                                                minWidth: "160px",
                                                                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                                                position: "relative",
                                                                overflow: "hidden",
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.transform = "translateY(-2px)";
                                                                e.currentTarget.style.boxShadow = "0 8px 25px rgba(255, 105, 180, 0.18)";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.transform = "translateY(0)";
                                                                e.currentTarget.style.boxShadow = "0 6px 20px rgba(255, 105, 180, 0.12)";
                                                            }}
                                                        >
                                                            {/* Decorative corner accent */}
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    top: -10,
                                                                    right: -10,
                                                                    width: "40px",
                                                                    height: "40px",
                                                                    background: "linear-gradient(135deg, #ff69b4 0%, #ff1493 100%)",
                                                                    opacity: 0.1,
                                                                    borderRadius: "50%",
                                                                    pointerEvents: "none",
                                                                }}
                                                            />

                                                            {product.promo ? (
                                                                <div style={{ display: "flex", flexDirection: "column", gap: "8px", alignItems: "center" }}>
                                                                    {/* Promo Badge with Animation */}
                                                                    <div
                                                                        style={{
                                                                            background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                                                                            color: "#fff",
                                                                            fontSize: "0.7rem",
                                                                            padding: "4px 14px",
                                                                            borderRadius: "30px",
                                                                            fontWeight: "700",
                                                                            letterSpacing: "0.8px",
                                                                            textTransform: "uppercase",
                                                                            boxShadow: "0 3px 10px rgba(40, 167, 69, 0.35)",
                                                                            animation: "pulse 2s infinite",
                                                                        }}
                                                                    >
                                                                        {product.promo_type === "percentage"
                                                                            ? `-${product.promo_percentage}%`
                                                                            : " PROMO"}
                                                                    </div>

                                                                    {/* Price Container */}
                                                                    <div style={{ display: "flex", flexDirection: "column", gap: "4px", width: "100%" }}>
                                                                        {/* Original Price - Elegant Strikethrough */}
                                                                        {product.oldPrice && (
                                                                            <div
                                                                                style={{
                                                                                    position: "relative",
                                                                                    color: "#aaa",
                                                                                    fontSize: "0.95rem",
                                                                                    fontWeight: "600",
                                                                                    display: "inline-block",
                                                                                }}
                                                                            >
                                                                                <span style={{ position: "relative" }}>
                                                                                    {parseFloat(product.oldPrice).toLocaleString("fr-FR", {
                                                                                        minimumFractionDigits: 3,
                                                                                        maximumFractionDigits: 3,
                                                                                    })}{" "}
                                                                                    <span style={{ fontSize: "0.75rem", fontWeight: "500" }}>DT</span>
                                                                                    {/* Custom strikethrough line */}
                                                                                    <div
                                                                                        style={{
                                                                                            position: "absolute",
                                                                                            top: "50%",
                                                                                            left: "-2px",
                                                                                            right: "-2px",
                                                                                            height: "2px",
                                                                                            background: "linear-gradient(90deg, transparent, #ff4444, transparent)",
                                                                                            transform: "translateY(-50%) rotate(-5deg)",
                                                                                        }}
                                                                                    />
                                                                                </span>
                                                                            </div>
                                                                        )}

                                                                        {/* New Discounted Price - Bold and Attractive */}
                                                                        <div
                                                                            style={{
                                                                                background: "linear-gradient(135deg, #ff1493 0%, #ff69b4 100%)",
                                                                                WebkitBackgroundClip: "text",
                                                                                WebkitTextFillColor: "transparent",
                                                                                backgroundClip: "text",
                                                                                fontSize: "0.95rem",
                                                                                fontWeight: "900",
                                                                                lineHeight: "1.1",
                                                                                letterSpacing: "-0.5px",
                                                                            }}
                                                                        >
                                                                            {(() => {
                                                                                let finalPrice = 0;

                                                                                if (product.promo_type === "percentage" && product.promo_percentage && product.oldPrice) {
                                                                                    finalPrice = parseFloat(product.oldPrice) * (1 - product.promo_percentage / 100);
                                                                                } else if (product.price_range) {
                                                                                    finalPrice = parseFloat(product.price_range);
                                                                                }

                                                                                return finalPrice.toLocaleString("fr-FR", {
                                                                                    minimumFractionDigits: 3,
                                                                                    maximumFractionDigits: 3,
                                                                                });
                                                                            })()}{" "}
                                                                            <span style={{ fontSize: "0.9rem", fontWeight: "700" }}>DT</span>
                                                                        </div>
                                                                    </div>

                                                                    {/* Savings Amount - Green Highlight */}
                                                                    {product.oldPrice && product.promo_percentage && (
                                                                        <div
                                                                            style={{
                                                                                fontSize: "0.75rem",
                                                                                color: "#28a745",
                                                                                fontWeight: "0.95rem",
                                                                                backgroundColor: "#d4edda",
                                                                                padding: "4px 12px",
                                                                                borderRadius: "20px",
                                                                                marginTop: "4px",
                                                                                border: "1px solid #c3e6cb",
                                                                            }}
                                                                        >
                                                                            💰 Économisez{" "}
                                                                            {(parseFloat(product.oldPrice) * (product.promo_percentage / 100)).toLocaleString("fr-FR", {
                                                                                minimumFractionDigits: 3,
                                                                                maximumFractionDigits: 3,
                                                                            })}{" "}
                                                                            DT
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                /* Regular Price - No Promo - Clean and Simple */
                                                                <div style={{ padding: "4px 0" }}>
                                                                    <div
                                                                        style={{
                                                                            color: "#2c3e50",
                                                                            fontSize: "0.95rem",
                                                                            fontWeight: "800",
                                                                            letterSpacing: "-0.3px",
                                                                        }}
                                                                    >
                                                                        {parseFloat(product.price_range || 0).toLocaleString("fr-FR", {
                                                                            minimumFractionDigits: 3,
                                                                            maximumFractionDigits: 3,
                                                                        })}{" "}
                                                                        <span style={{ fontSize: "0.9rem", fontWeight: "600", color: "#5a6c7d" }}>DT</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}

                                                    <style jsx>{`
  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
  }
`}</style>

                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center mt-4">
                                        <p className="fs-5">
                                            🐾 Aucun produit trouvé pour "{selectedCategory}".
                                        </p>
                                        {/* Bouton debug temporaire */}
                                        <button
                                            onClick={() => {
                                                console.log("📊 Debug - Tous les produits:", products);
                                                console.log("📊 Debug - Catégorie sélectionnée:", selectedCategory);
                                                console.log("📊 Debug - Filtres actifs:", { selectedSubcategory, searchTerm, selectedMaxPrice });
                                            }}
                                            style={{
                                                background: '#ff69b4',
                                                color: 'white',
                                                padding: '10px 20px',
                                                border: 'none',
                                                borderRadius: '5px',
                                                marginTop: '10px'
                                            }}
                                        >
                                            🔍 Debug dans Console
                                        </button>
                                    </div>
                                )}
                            </div>

                            {filteredProducts.length > productsPerPage && (
                                <div className="pagination-controls mt-4 text-center">
                                    {Array.from({ length: totalPages }, (_, index) => (
                                        <button
                                            key={index}
                                            onClick={() => {
                                                setCurrentPage(index + 1);
                                                window.scrollTo({ top: 400, behavior: "smooth" });
                                            }}
                                            style={{
                                                padding: "8px 14px",
                                                margin: "0 5px",
                                                borderRadius: "6px",
                                                border: "1px solid #ccc",
                                                backgroundColor: currentPage === index + 1 ? "#c71585" : "#fff",
                                                color: currentPage === index + 1 ? "#fff" : "#333",
                                                cursor: "pointer",
                                                fontWeight: "500",
                                            }}
                                        >
                                            {index + 1}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Mobile Filter Sidebar - Même corrections */}
                 {showFilter && (
  <>
    {/* ✅ Backdrop — tap outside to close */}
    <div
      onClick={() => setShowFilter(false)}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        zIndex: 999,
      }}
    />

    <div className="mobile-filter-sidebar" style={{ zIndex: 1000 }}>
      <div className="sidebar-content">
        {/* search, categories, price — unchanged */}

        <div className="widget">
          <h4 className="sidebar-title">Catégories</h4>
          <div className="shop-cat-list">
            <ul>
              {categories.map((cat) => (
                <li key={cat.name}>
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedCategory(cat.name);
                      setSelectedSubcategory("");
                      setShowFilter(false);  // ✅ close on category select
                    }}
                  >
                    {cat.name} <span>+</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* price filter — unchanged */}

        <button
          className="close-filter-btn"
          onClick={() => setShowFilter(false)}
          style={{
            backgroundColor: "#ff69b4",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "50%",
            fontSize: "18px",
            position: "absolute",
            top: "20px",
            right: "20px",
            zIndex: 1001,
          }}
        >
          <i className="fa fa-times" />
        </button>
      </div>
    </div>
  </>
)}
                </div>
            </div>
        </div>
    );
}
export default ShopAll;
